var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import MFA from "@irati/auth/utils/mfa";
import modalStory, { anyStoriesOpen } from "@irati/utils/modalStory";
import RequestCode from "./Request";
import MFASetup from "./Setup";
import EnterCode from "./EnterCode";
export var Screens;
(function (Screens) {
    Screens["REQUEST"] = "REQUEST";
    Screens["SETUP"] = "SETUP";
    Screens["ENTER"] = "ENTER";
})(Screens || (Screens = {}));
var modals = [Screens.REQUEST, Screens.SETUP, Screens.ENTER];
var MFAPopup = /** @class */ (function (_super) {
    __extends(MFAPopup, _super);
    function MFAPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMFAStateChange = function () {
            _this.setState({ screen: modalStory(modals, Screens.REQUEST) });
        };
        _this.selectScreen = function (screen, extraData) {
            _this.setState({ screen: modalStory(modals, screen), extraData: extraData });
        };
        _this.handleCancel = function () {
            MFA.cancel();
            _this.selectScreen(null);
        };
        _this.state = {
            screen: modalStory(modals, null)
        };
        return _this;
    }
    MFAPopup.prototype.componentDidMount = function () {
        MFA.addEventListener(this.handleMFAStateChange);
    };
    MFAPopup.prototype.render = function () {
        var _a = this.state, screen = _a.screen, extraData = _a.extraData;
        if (!anyStoriesOpen(screen)) {
            return null;
        }
        var phoneNumber = "";
        if (extraData && extraData.phoneNumber) {
            phoneNumber = extraData.phoneNumber;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(RequestCode, { show: screen[Screens.REQUEST], onCancel: this.handleCancel, selectScreen: this.selectScreen }),
            React.createElement(MFASetup, { show: screen[Screens.SETUP], onCancel: this.handleCancel, selectScreen: this.selectScreen }),
            React.createElement(EnterCode, { show: screen[Screens.ENTER], onCancel: this.handleCancel, selectScreen: this.selectScreen, phoneNumber: phoneNumber })));
    };
    return MFAPopup;
}(PureComponent));
export default MFAPopup;
